<template>
    <b-navbar toggleable="lg" type="dark" variant="dark">
        <b-navbar-brand to="/">What2Watch?</b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav v-if="user">
            <b-nav-item to="/create-event">Create event</b-nav-item>
            
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
            <b-nav-item href="https://barooney.com" target="_blank">Barooney.com</b-nav-item>
            <b-nav-item v-if="!user" to="/signin">Sign in</b-nav-item>
            <b-button variant="outline-primary" v-if="!user" to="/register">Sign up</b-button>
            <b-nav-item-dropdown right v-else>
                <!-- Using 'button-content' slot -->
                <template slot="button-content">{{ displayName }}</template>
                <b-dropdown-item to="/profile">Profile</b-dropdown-item>
                <b-dropdown-item to="/signout">Logout</b-dropdown-item>
            </b-nav-item-dropdown>
        </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
import firebase from 'firebase'

import {mapState} from 'vuex'
export default {
    computed: {
        ...mapState(['user', 'displayName'])
    },
    mounted() {
    },
    methods: {
        async logout() {
            await this.$auth.logout()
        }
    }
}
</script>